// Curated karaoke batches for cache warm-up. Each entry is loaded on demand
// from the YouTube quota dashboard. Songs already cached are skipped (0 quota).
export const KARAOKE_BATCHES = [
  // ===== BATCH 1 =====
  [
    "Amor Eterno", "Querida", "Abrázame Muy Fuerte", "Hasta Que Te Conocí", "Así Fue",
    "Se Me Olvidó Otra Vez", "No Tengo Dinero", "Siempre en Mi Mente", "Te Lo Pido por Favor",
    "El Noa Noa", "El Triste", "La Nave del Olvido", "Almohada", "Lo Pasado Pasado",
    "Amar y Querer", "Volcán", "Gavilán o Paloma", "40 y 20", "El Amor Acaba", "Preso",
    "Amigo", "Detalles", "Un Millón de Amigos", "Jesús Cristo", "Lady Laura",
    "Vivir Así Es Morir de Amor", "Algo de Mí", "Perdóname", "Jamás", "Quieres Ser Mi Amante",
    "¿Y Cómo Es Él?", "Un Velero Llamado Libertad", "Te Quiero", "Que Canten los Niños",
    "Me Llamas", "Tan Enamorados", "Me Va a Extrañar", "Castillo Azul", "La Cima del Cielo",
    "Bésame", "Te Amo", "No Basta", "Un Buen Perdedor", "Tú de Qué Vas", "Si La Ves",
    "Azul", "No Podrás", "Lloran las Rosas", "Por Amarte Así", "Nunca Voy a Olvidarte",
    "Corazón Partío", "Amiga Mía", "Cuando Nadie Me Ve", "Mi Soledad y Yo", "Quisiera Ser",
    "A Dios le Pido", "Es Por Ti", "Fotografía", "Nada Valgo Sin Tu Amor", "Para Tu Amor",
    "Color Esperanza", "Sueños", "Penélope", "Tratar de Estar Mejor", "Abriendo Caminos",
    "Rayando el Sol", "Oye Mi Amor", "Vivir Sin Aire", "Bendita Tu Luz", "De Música Ligera",
    "Persiana Americana", "Cuando Pase el Temblor", "Lamento Boliviano", "Tu Cárcel",
    "Devuélveme a Mi Chica", "La Flaca", "Bonito", "Caraluna", "Mi Primer Millón",
  ],
  // ===== BATCH 2 =====
  [
    "Simplemente Amigos", "Quién Como Tú", "Ay Amor", "Luna", "Evidencias",
    "Es Demasiado Tarde", "No Te Hago Falta", "Pecado Original", "La Gata Bajo la Lluvia",
    "Costumbres", "Como Tu Mujer", "Me Gustas Mucho", "Fue Tan Poco Tu Cariño",
    "Jamás Te Dejaré", "Maldita Primavera", "Detrás de Mi Ventana", "Cuando Baja la Marea",
    "Qué Te Pasa", "Yo Te Pido Amor", "El Apagón", "Él Me Mintió", "Así No Te Amará Jamás",
    "Mi Buen Corazón", "Castillos", "El Hombre Que Yo Amo", "Huele a Peligro", "Herida",
    "Te Pareces Tanto a Él", "Se Fue", "Amores Extraños", "La Soledad", "Víveme",
    "En Cambio No", "Inolvidable", "Rosas", "La Playa", "20 de Enero", "Puedes Contar Conmigo",
    "Jueves", "Limón y Sal", "Me Voy", "Andar Conmigo", "Lento", "Eres Para Mí", "Antología",
    "Ciega Sordomuda", "Ojos Así", "Inevitable", "Moscas en la Casa", "Estoy Aquí", "Tú",
    "No", "Suerte", "Que Me Quedes Tú", "Día de Enero", "Gitana", "Lo Hecho Está Hecho",
    "Acróstico", "A Quién Le Importa", "Ni Tú Ni Nadie", "Mujer Contra Mujer", "Hijo de la Luna",
    "La Fuerza del Destino", "Me Cuesta Tanto Olvidarte", "Cómo Hemos Cambiado",
    "Una Rosa Es Una Rosa", "Eres Tú", "Amor de Hombre", "Tómame o Déjame", "Secretaria",
    "Paloma Negra", "Cucurrucucú Paloma", "La Media Vuelta", "Volver Volver",
    "Amanecí en Tus Brazos", "Bésame Mucho", "Historia de un Amor", "Sabor a Mí",
    "Solamente Una Vez",
  ],
  // ===== BATCH 3 =====
  [
    "Entra en Mi Vida", "Kilómetros", "Mientes Tan Bien", "Sirena", "Que Lloro",
    "Suelta Mi Mano", "Te Vi Venir", "Y Llegaste Tú", "Cómo Te Va Mi Amor", "Sólo Él y Yo",
    "Cuando No Estás Conmigo", "Alguien Llena Mi Lugar", "No Controles", "Bazar",
    "Las Mil y Una Noches", "Tímido", "Olvídame y Pega la Vuelta", "A Esa", "Valiente",
    "Hermanos", "Todo Cambió", "Mientes", "Aléjate de Mí", "Coleccionista de Canciones",
    "Bésame", "Noviembre Sin Ti", "Creo en Ti", "Inolvidable", "Yo Quisiera", "Tabaco y Chanel",
    "Pasos de Gigante", "Por", "Rosas", "Cuídate", "Puedes Contar Conmigo", "La Playa",
    "20 de Enero", "Eres", "Las Flores", "Chilanga Banda", "María", "La Celula Que Explota",
    "Lucha de Gigantes", "Venezia", "Temblando", "Visite Nuestro Bar",
    "Marta Tiene un Marcapasos", "Lo Noto", "Creo en Ti", "Me Niego", "Noviembre Sin Ti",
    "Que Vida La Mía", "Te Regalo", "Mientes", "Todo Cambió", "Aléjate de Mí", "Bendita Tu Luz",
    "El Verdadero Amor Perdona", "Labios Compartidos", "Mariposa Traicionera",
    "Clavado en un Bar", "En el Muelle de San Blas", "Volverte a Ver", "Me Enamora",
    "La Camisa Negra", "Volví a Nacer", "Déjame Entrar", "Fruta Fresca", "Carito",
    "Robarte un Beso", "Tacones Rojos", "Traicionera", "A Dios le Pido", "Es Por Ti",
    "Fotografía", "Color Esperanza", "Sueños", "Penélope", "Abriendo Caminos",
  ],
  // ===== BATCH 4 =====
  [
    "Vivir Mi Vida", "Valió la Pena", "Flor Pálida", "Tu Amor Me Hace Bien", "Te Conozco Bien",
    "Ahora Quién", "Y Hubo Alguien", "La Vida Es Un Carnaval", "Quimbara", "Guantanamera",
    "Llorarás", "Detalles", "Cali Pachanguero", "Una Aventura", "Volveré", "Gotas de Lluvia",
    "Procura", "Suavemente", "Píntame", "Tú Me Quemas", "Pégame Tu Vicio", "La Bilirrubina",
    "Ojalá Que Llueva Café", "Burbujas de Amor", "Bachata Rosa", "Frío Frío",
    "Visa Para Un Sueño", "El Niágara en Bicicleta", "A Pedir Su Mano", "Como Abeja al Panal",
    "Pedro Navaja", "Decisiones", "Amor y Control", "Buscando América", "Plástico",
    "Caballo Viejo", "El Africano", "Abusadora", "Colegiala", "La Ventanita",
    "Bohemian Rhapsody", "Don't Stop Me Now", "We Will Rock You", "We Are The Champions",
    "Sweet Caroline", "My Way", "New York New York", "Hotel California", "Take It Easy",
    "Wonderwall", "Don't Look Back In Anger", "Take On Me", "Dancing Queen", "Mamma Mia",
    "Fernando", "Waterloo", "Country Roads", "Annie's Song", "Stand By Me",
    "Can't Help Falling In Love", "Love Me Tender", "Careless Whisper", "Faith",
    "Wake Me Up Before You Go-Go", "Summer of '69", "Heaven", "Everything I Do",
    "Livin' On A Prayer", "It's My Life", "Don't Stop Believin'", "Open Arms", "Faithfully",
    "Perfect", "Thinking Out Loud", "Someone Like You", "I Want It That Way", "Billie Jean",
    "Just The Way You Are",
  ],
  // ===== BATCH 5 =====
  [
    "Sabor a Mí", "Solamente Una Vez", "Contigo Aprendí", "Somos Novios", "La Barca",
    "El Reloj", "Bésame Mucho", "Perfidia", "Historia de un Amor", "Sin Ti",
    "Reloj No Marques las Horas", "Usted", "Toda una Vida", "Piel Canela", "Somos Diferentes",
    "Cien Años", "Siete Notas de Amor", "Noche de Ronda", "Caminemos", "Voy a Apagar la Luz",
    "El Rey", "Si Nos Dejan", "Caminos de Guanajuato", "Serenata Huasteca",
    "Amanecí en Tus Brazos", "Hermoso Cariño", "México Lindo y Querido", "Cielo Rojo",
    "Entrega Total", "Paloma Querida", "De Qué Manera Te Olvido", "Mujeres Divinas",
    "Acá Entre Nos", "Estos Celos", "Volver Volver", "Por Tu Maldito Amor", "La Diferencia",
    "El Último Trago", "Que Bonito Amor", "La Bikina", "Amor de Mis Amores", "La Boa",
    "Payaso de Rodeo", "17 Años", "Cómo Te Voy a Olvidar", "Nunca Es Suficiente",
    "Mis Sentimientos", "El Listón de Tu Pelo", "Tu Cárcel", "Mi Mayor Necesidad",
    "Y Todo Para Qué", "Querida Socia", "El Final de Nuestra Historia", "Abeja Reina",
    "El Sinaloense", "El Color de Tus Ojos", "Mi Razón de Ser", "Ya Te Perdí la Fe",
    "Mi Último Deseo", "Te Presumo", "Yesterday", "Let It Be", "Hey Jude",
    "All You Need Is Love", "Imagine", "Woman", "Piano Man", "Honesty",
    "Just the Way You Are (Billy Joel)", "She's Always a Woman", "Bridge Over Troubled Water",
    "The Sound of Silence", "Mrs. Robinson", "American Pie", "Leaving on a Jet Plane",
    "Dust in the Wind", "Have You Ever Seen the Rain", "Proud Mary", "Unchained Melody",
    "Can't Take My Eyes Off You", "I Just Called to Say I Love You",
  ],
  // ===== BATCH 6 =====
  [
    "Isn't She Lovely", "Overjoyed", "Ebony and Ivory", "Against All Odds", "One More Night",
    "You Can't Hurry Love", "Every Breath You Take", "Fields of Gold",
    "Englishman in New York", "Right Here Waiting", "When a Man Loves a Woman", "Endless Love",
    "The Power of Love", "Because You Loved Me", "I Swear", "Wonderful Tonight",
    "Tears in Heaven", "Killing Me Softly", "Top of the World",
  ],
];
